/**
 * Arama sonucu metinleri için ortak yardımcılar (istemci SEO bileşeni + sunucu SSR).
 * Google başlığı ~60, açıklamayı ~155-160 karakterden sonra keser; uzun metinler cümle
 * sınırından kısaltılır, kesilen cümle yarım kalmaz.
 */

export const MARKA = "Dijipo";

/**
 * Başlığa marka eki. Başlıkta zaten "Dijipo" geçiyorsa ya da ek başlığı 60 karakterin üzerine
 * taşıyacaksa eklenmez: Google site adını ayrıca gösterir, ek ise anahtar kelimeleri kesilen kısma iter.
 */
export function tamBaslik(baslik: string): string {
  const t = baslik.replace(/\s*\|\s*Dijipo.*$/i, "").trim();
  const ekli = `${t} | ${MARKA}`;
  return /dijipo/i.test(t) || ekli.length > 60 ? t : ekli;
}

/** Açıklamayı en fazla `max` karaktere indirir: önce cümle sonu, olmazsa kelime sınırı + "…". */
export function kisaAciklama(metin: string, max = 158): string {
  const s = metin.replace(/\s+/g, " ").trim();
  if (s.length <= max) return s;
  const kesit = s.slice(0, max);
  const cumle = Math.max(kesit.lastIndexOf(". "), kesit.lastIndexOf("? "), kesit.lastIndexOf("! "));
  if (cumle >= 90) return kesit.slice(0, cumle + 1);
  if (/[.?!]$/.test(kesit) && kesit.length >= 90) return kesit;
  const bosluk = kesit.slice(0, max - 1).lastIndexOf(" ");
  return kesit.slice(0, bosluk > 0 ? bosluk : max - 1).replace(/[\s,;:–—-]+$/, "") + "…";
}
